<template>
  <page>
    <template slot="section">
      <div class="slider">
        <Heading v-if="slides" type="h1">{{ slides[currentSlider].title }}</Heading>
        <ul>
          <li
            v-for="(slide, index) in slides"
            :key="index"
            :data-index="index"
            :class="[ index === currentSlider ? 'active' : 'default' ]"
            @click="setCurrentSlide"
          />
        </ul>
      </div>
    </template>
    <template slot="aside">
      <slider :key="currentSlider" :index="currentSlider" :slides="slides"/>
    </template>
  </page>
</template>

<script>
import Page from '@/components/Page';
import Heading from '@/components/Heading';
import Slider from '@/components/slider/Slider';

export default {
  components: {
    Page, Heading, Slider,
  },
  data () {
    return {
      currentSlider: 0,
      interval: null,
      slides: null,
      images: [
        require('@/components/slider/img-01.jpg'),
        require('@/components/slider/img-02.jpg'),
        require('@/components/slider/img-03.jpg')
      ],
      logos: [
        require("@/components/slider/minerg.png"),
        require("@/components/slider/fas.png"),
        require("@/components/slider/advice.png"),
        require("@/components/slider/npgk.png"),
        require("@/components/slider/sun.png"),
        require("@/components/slider/ats.png")
      ],
      map: require('@/components/slider/map.png')
    }
  },
  mounted () {
    this.slides = require('@/components/slider/items.json');
    this.slides = this.slides.map((el, i) => ({
      ...el,
      image: this.images[i],
      ...(i === 0 ? { logos: this.logos } : {}),
      ...(i === 1 ? { map: this.map } : {})
    }));
    this.setTimeout();
  },
  beforeDestroy () {
    window.clearInterval(this.interval);
  },
  methods: {
    setCurrentSlide (evt) {
      this.currentSlider = +evt.target.attributes['data-index'].value;
      this.clearTimeout();
      this.setTimeout();
    },
    setTimeout () {
      this.interval = window.setInterval(() => {
        this.currentSlider = (this.currentSlider + 1) % this.slides.length;
      }, 7000)
    },
    clearTimeout () {
      window.clearTimeout(this.interval);
    }
  }
}
</script>

<style lang="scss">
.slider {
  display: flex;
  flex-flow: column;
  position: absolute;
  bottom: 0;
  width: 66%;
  @media (max-width: 767px) {
    position: relative;
    bottom: auto;
    width: 100%;
  }

  ul {
    list-style: none;
    @media (max-width: 767px) {
      margin: 0 -10px;
      display: flex;
    }

    li {
      display: inline-block;
      background: #DFDFDF;
      width: 42px;
      height: 4px;
      margin: 0 10px 0 0;
      cursor: pointer;

      &.active {
        cursor: default;
        background: #1E252E;
      }
      @media (max-width: 767px) {
        margin: 0;
        width: 100%;
        height: 25px;
        opacity: .5;
        margin: 0 0 -25px;
        position: relative;
        z-index: 10;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// Home.vue?2f255aa0